import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import Home from '../components/layout/Home/Home'
import Inicio from '../components/layout/Home/Inicio'
import Login from '../components/layout/Login/Login'
import ListadoUsuarios from '../components/layout/Login/ListadoUsuarios'
import Logout from '../components/layout/Login/Logout'
import AuthContextProvider from "./contexts/AuthContext.js";

// Logs
import Logs from './views/Logs/ListadoLogs'

// Clientes
import ListadoClientes from "./views/Clientes/ListadoClientes"
import ClientesCreate from "./views/Clientes/ClientesCreate"

// Cargos
import ListadoCargos from "./views/Cargos/ListadoCargos"
import CargosCreate from "./views/Cargos/CargosCreate"
import ReporteCargos from "./views/Cargos/ReporteCargos"

// Abonos
import ListadoAbonos from "./views/Abonos/ListadoAbonos"
import AbonosCreate from "./views/Abonos/AbonosCreate"
import ListadoAnticiposClientes from "./views/Abonos/ListadoAnticiposClientes"

// Mensualidades
import ListadoMensualidades from "./views/Mensualidades/ListadoMensualidades"
import MensualidadesCreate from "./views/Mensualidades/MensualidadesCreate"

// Estado Cuenta
import EstadoCuenta from "./views/EstadoCuenta/EstadoCuenta";

// Gastos
import BotonesGastos from "./views/Gastos/BotonesGastos"
import ListadoGastosGeneral from './views/Gastos/GastosGeneral/ListadoGastosGeneral'
import GastosGeneralCreate from './views/Gastos/GastosGeneral/GastosGeneralCreate'
import ListadoConceptosGastos from './views/Gastos/ConceptosGastos/ListadoConceptosGastos'
import ConceptosGastosCreate from './views/Gastos/ConceptosGastos/ConceptosGastosCreate'

// Tickets
import BotonesTickets from "./views/Tickets/BotonesTickets"
import ListadoModulos from './views/Tickets/Modulos/ListadoModulos'
import ListadoTickets from "./views/Tickets/Tickets/ListadoTickets"
import TicketsCreate from "./views/Tickets/Tickets/TicketsCreate"

//Reportes
import BotonesReportes from "./views/Reportes/BotonesReportes";
import GraficaVentasMensual from "./views/Reportes/GraficaVentasMensual";
import GraficaVentasAnual from "./views/Reportes/GraficaVentasAnual";
import GraficaAbonosMensual from "./views/Reportes/GraficaAbonosMensual";
import GraficaVentasComparativa from "./views/Reportes/GraficaVentasComparativa";
import BalanceMensual from "./views/Reportes/BalanceMensual"
import BalanceMensualV2 from "./views/Reportes/BalanceMensualV2"
import BalanceAnual from "./views/Reportes/BalanceAnual"
import ClientesActivos from "./views/Reportes/ClientesActivos"

// Retiros
import BotonesRetiros from "./views/Retiros/BotonesRetiros.jsx";
import ListadoSocios from "./views/Retiros/Socios/ListadoSocios.jsx";
import ListadoRetiros from "./views/Retiros/Retiros/ListadoRetiros.jsx";
import RetirosCreate from "./views/Retiros/Retiros/RetirosCreate.jsx";
import ListadoPorRetirar from "./views/Retiros/PorRetirar/ListadoPorRetirar.jsx";
import PorRetirarCreate from "./views/Retiros/PorRetirar/PorRetirarCreate.jsx";


// IA
import AIChat from "./AI/AIChat";

// Fiscal
import BotonesFiscal from "./views/Fiscal/BotonesFiscal";
import ListadoFacturas from "./views/Fiscal/Facturacion/ListadoFacturas.jsx";
import FacturasCreate from "./views/Fiscal/Facturacion/FacturasCreate.jsx";
import ListadoComplementosPago from "./views/Fiscal/ComplementosPago/ListadoComplementosPago.jsx";
import ComplementosPagoCreate from "./views/Fiscal/ComplementosPago/ComplementosPagoCreate.jsx";
import NotasCreditoCreate from "./views/Fiscal/NotasCredito/NotasCreditoCreate.jsx";
import ListadoNotasCredito from "./views/Fiscal/NotasCredito/ListadoNotasCredito.jsx";
import RegistrarEmpresas from "./views/Fiscal/RegistrarEmpresa/RegistrarEmpresas.jsx";
import ListadoPagosFacturas from "./views/Fiscal/ComplementosPago/ListadoPagosFacturas.jsx";
import EstadoCuentaK from "./views/Fiscal/EstadoCuentaK/EstadoCuentaK.jsx";
import ListadoEmpresas from "./views/Fiscal/Empresas/ListadoEmpresas";

// Lugares Fiestas (módulo separado)
import ReservaPublica from "./views/LugaresFiestas/ReservaPublica";
import ReservaExito from "./views/LugaresFiestas/ReservaExito";
import ReservaCancelado from "./views/LugaresFiestas/ReservaCancelado";
import ListadoLugaresFiestas from "./views/LugaresFiestas/ListadoLugaresFiestas";

function Routes() {
    return (
        <AuthContextProvider>
            <BrowserRouter>
            <Switch>
                {/* Rutas públicas */}
                <Route exact path="/" component={Home} />
                <Route exact path="/Login" component={Login} />
                <Route exact path="/Logout" component={Logout} />

                {/* Lugares Fiestas — páginas públicas (fuera del guard) */}
                <Route exact path="/lugares-fiestas" component={ReservaPublica} />
                <Route exact path="/lugares-fiestas/exito" component={ReservaExito} />
                <Route exact path="/lugares-fiestas/cancelado" component={ReservaCancelado} />

                {/* Rutas protegidas */}
                <PrivateRoute exact path="/Inicio" component={Inicio} />
                <PrivateRoute exact path="/ListadoUsuarios" component={ListadoUsuarios} />
                {/* Logs */}
                <PrivateRoute exact path="/MenuLogs" component={Logs} />
                {/* Clientes */}
                <PrivateRoute exact path="/ListadoClientes" component={ListadoClientes} />
                <PrivateRoute exact path="/ClientesCreate" component={ClientesCreate} />
                {/* Cargos */}
                <PrivateRoute exact path="/ListadoCargos" component={ListadoCargos} />
                <PrivateRoute exact path="/CargosCreate" component={CargosCreate} />
                <PrivateRoute exact path="/ReporteCargos" component={ReporteCargos} />
                {/* Abonos */}
                <PrivateRoute exact path="/ListadoAbonos" component={ListadoAbonos} />
                <PrivateRoute exact path="/AbonosCreate" component={AbonosCreate} />
                <PrivateRoute exact path="/AnticiposClientes" component={ListadoAnticiposClientes} />
                {/* Mensualidades */}
                <PrivateRoute exact path="/ListadoMensualidades" component={ListadoMensualidades} />
                <PrivateRoute exact path="/MensualidadesCreate" component={MensualidadesCreate} />
                {/* Estado de Cuenta */}
                <PrivateRoute exact path="/EstadoCuenta" component={EstadoCuenta} />
                {/* Gastos */}
                <PrivateRoute exact path="/MenuGastos" component={BotonesGastos} />
                <PrivateRoute exact path="/Gastos" component={ListadoGastosGeneral} />
                <PrivateRoute exact path="/GastosCreate" component={GastosGeneralCreate} />
                <PrivateRoute exact path="/ConceptosGastos" component={ListadoConceptosGastos} />
                <PrivateRoute exact path="/conceptosGastosCreate" component={ConceptosGastosCreate} />
                {/* Tickets */}
                <PrivateRoute exact path="/MenuTickets" component={BotonesTickets} />
                <PrivateRoute exact path="/ListadoModulos" component={ListadoModulos} />
                <PrivateRoute exact path="/ListadoTickets" component={ListadoTickets} />
                <PrivateRoute exact path="/TicketsCreate" component={TicketsCreate} />
                {/* Reportes */}
                <PrivateRoute exact path="/MenuReportes" component={BotonesReportes} />
                <PrivateRoute exact path="/GraficaVentasMensual" component={GraficaVentasMensual} />
                <PrivateRoute exact path="/GraficaVentasAnual" component={GraficaVentasAnual} />
                <PrivateRoute exact path="/GraficaAbonosMensual" component={GraficaAbonosMensual} />
                <PrivateRoute exact path="/GraficaVentasComparativa" component={GraficaVentasComparativa} />
                <PrivateRoute exact path="/BalanceMensual" component={BalanceMensual} />
                <PrivateRoute exact path="/BalanceMensualV2" component={BalanceMensualV2} />
                <PrivateRoute exact path="/BalanceAnual" component={BalanceAnual} />
                <PrivateRoute exact path="/ClientesActivos" component={ClientesActivos} />
                {/* Retiros */}
                <PrivateRoute exact path="/MenuRetiros" component={BotonesRetiros} />
                <PrivateRoute exact path="/Socios" component={ListadoSocios} />
                <PrivateRoute exact path="/Retiros" component={ListadoRetiros} />
                <PrivateRoute exact path="/RetirosCreate" component={RetirosCreate} />
                <PrivateRoute exact path="/PorRetirar" component={ListadoPorRetirar} />
                <PrivateRoute exact path="/PorRetirarCreate" component={PorRetirarCreate} />
                {/* Fiscal */}
                <PrivateRoute exact path="/MenuFiscal" component={BotonesFiscal} />
                <PrivateRoute exact path="/ListadoFacturas" component={ListadoFacturas} />
                <PrivateRoute exact path="/FacturasCreate" component={FacturasCreate} />
                <PrivateRoute exact path="/ListadoComplementosPago" component={ListadoComplementosPago} />
                <PrivateRoute exact path="/ComplementosPagoCreate" component={ComplementosPagoCreate} />
                <PrivateRoute exact path="/ListadoNotasCredito" component={ListadoNotasCredito} />
                <PrivateRoute exact path="/NotasCreditoCreate" component={NotasCreditoCreate} />
                <PrivateRoute exact path="/RegistrarEmpresas" component={RegistrarEmpresas} />
                <PrivateRoute exact path="/ListadoPagosFacturas" component={ListadoPagosFacturas} />
                <PrivateRoute exact path="/EstadoCuentaK" component={EstadoCuentaK} />
                <PrivateRoute exact path="/ListadoEmpresas" component={ListadoEmpresas} />
                {/* Lugares Fiestas — admin (protegida) */}
                <PrivateRoute exact path="/LugaresFiestas" component={ListadoLugaresFiestas} />
            </Switch>
            <AIChat />
            </BrowserRouter>
            </AuthContextProvider>
    );
}

export default Routes
